import type { Alpine } from 'alpinejs'

declare global {
    interface Window {
        Alpine: Alpine
    }
}

/**
 * Livewire ships its own Alpine, so a page carrying a Livewire component boots through
 * the Livewire bundle; every other page gets bare Alpine and never downloads Livewire.
 */
export default async function startAlpine(): Promise<void> {
    if (document.querySelector('[wire\\:snapshot]')) {
        const { Livewire } = await import('@livewire')
        Livewire.start()
        return
    }

    const { default: Alpine } = await import('alpinejs')
    window.Alpine = Alpine
    Alpine.start()
}
